import { FlowComponentDefinition } from "../../interface/functionalityInterface";
import { OUTLINE_COLOR, renderStraightArrow, renderStraightPulse } from "./renderingUtils";

export const pumpComponent: FlowComponentDefinition = {
  type: "pump",
  title: "pump",
  category: "Equipment",
  visualKind: "pump",
  defaultColor: "#9ea4ab",
  previewFlow: { from: "left", to: "right" },
  ports: ["left", "right"],
  incomingDirections: ["left"],
  outgoingDirections: ["right"],
  defaults: { pressure: "2", flow: "25" },
  fields: [
    { key: "pressure", label: "Pressure" },
    { key: "flow", label: "Flow" },
    { key: "color", label: "Color", inputType: "color" },
  ],
  renderGraphic: (context) => {
    const transform = context.isHorizontal ? undefined : "rotate(90 50 50)";

    return (
      <g transform={transform}>
        <line x1="0" y1="50" x2="22" y2="50" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <line x1="78" y1="50" x2="100" y2="50" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <circle cx="50" cy="50" r="27" fill="#ffffff" stroke={OUTLINE_COLOR} strokeWidth="2.2" />
        <line x1="34" y1="75" x2="69" y2="29" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        {renderStraightArrow(context)}
      </g>
    );
  },
  renderAnimatedFlow: (context) => renderStraightPulse(context),
};
